import { ChangeDetectorRef, Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { TalkToDoctorService } from '../api-services/talk-to-doctor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import {
  endOfDay,
  addMonths, format, addMinutes, startOfMinute
} from 'date-fns';
import {
  DAYS_IN_WEEK,
  SchedulerViewDay,
  SchedulerViewHour,
  SchedulerViewHourSegment,
  CalendarSchedulerEvent,
  CalendarSchedulerEventAction,
  startOfPeriod,
  endOfPeriod,
  addPeriod,
  subPeriod,
  SchedulerDateFormatter,
  SchedulerEventTimesChangedEvent,
  CalendarSchedulerViewComponent
} from 'angular-calendar-scheduler';
import {
  CalendarView,
  CalendarDateFormatter,
  DateAdapter
} from 'angular-calendar';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { ViewportScroller } from '@angular/common';
/**
 * This component is using for user request appointment to the selected doctor
 * and schedule the appointment and user info submit that appointment request.
 * For schedule the appointment using angular calendar schedular
 */
@Component({
  selector: 'app-requestappoinment',
  templateUrl: './requestappoinment.component.html',
  styleUrls: ['./requestappoinment.component.css'],
  providers: [{
    provide: CalendarDateFormatter,
    useClass: SchedulerDateFormatter
  }]
})
export class RequestappoinmentComponent implements OnInit {
  @ViewChild('msg')modalRef:any;
  requestForm = this.fb.group({
    appointmentId: new FormControl(''),
    doctorId: new FormControl(),
    toWhom: new FormControl("", Validators.required),
    detailsDto: this.fb.group({
      memberId: '0',
      firstName: new FormControl("", [Validators.required, Validators.minLength(3), Validators.maxLength(35), Validators.pattern('^[a-zA-Z \-\']+')]),
      lastName: new FormControl("", [Validators.required, Validators.minLength(3), Validators.maxLength(35), Validators.pattern('^[a-zA-Z \-\']+')]),
      dob: new FormControl("", Validators.required),
      genderId: new FormControl(null, Validators.required),
      relation: new FormControl(null),
      phoneNumber: new FormControl("", [Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),

    }),
    refferedBy: new FormControl(''),
    appointmentDate: new FormControl("", Validators.required),
    appointmentTime: new FormControl(""),
    modeOfConsultation: new FormControl("", Validators.required),
    additionalInfo: new FormControl(),
    service: new FormControl("")
  });
  typeToWhom: any = "";
  isToggle: boolean;
  fileName: any = [];
  typeMode: any;
  gender: any;
  doctorId: any
  acceptFilesFormat = ".pdf,.doc,.docx,.jpeg,.jpg,.png"
  //Event Calendar 

  CalendarView = CalendarView;

  view: CalendarView = CalendarView.Week;
  viewDate: Date = new Date();
  viewDays: number = 7;
  refresh: Subject<any> = new Subject();
  locale: string = 'en';
  hourSegments: number = 2;
  weekStartsOn: number = 1;
  startsWithToday: boolean = true;
  activeDayIsOpen: boolean = true;
  excludeDays: number[] = []; // [0];
  dayStartHour: number = 0;
  dayEndHour: number = 24;

  minDate: Date = new Date();
  maxDate: Date = endOfDay(addMonths(new Date(), 2));
  dayModifier: Function;
  hourModifier: Function;
  segmentModifier: Function;
  eventModifier: Function;
  prevBtnDisabled: boolean = false;
  nextBtnDisabled: boolean = false;
  count = 0

  events: CalendarSchedulerEvent[] = [];

  @ViewChild(CalendarSchedulerViewComponent) calendarScheduler: CalendarSchedulerViewComponent;

  actions: CalendarSchedulerEventAction[] = [
    {
      when: 'enabled',
      label: '<span class="valign-center"><i class="bi bi-x-circle-fill  iconClr"></i>Delete</span>',
      title: 'Delete',
      onClick: (event: CalendarSchedulerEvent): void => {
        this.events = this.events.filter(item => item.title !== event.title);
        this.count = 0
        this.refresh.next()
        this.requestForm.get('appointmentDate').patchValue("");
      }
    },
    {
      when: 'cancelled',
      label: '<span class="valign-center"><i class="material-icons md-18 md-red-500">autorenew</i></span>',
      title: 'Restore',
      onClick: (event: CalendarSchedulerEvent): void => {
        // console.log('Pressed action \'Restore\' on event ' + event.id);
      }
    }
  ];
  maxdate: Date;

  constructor(public doctorService: TalkToDoctorService, private scroller: ViewportScroller,
    public fb: FormBuilder, private router: Router, public modalService: BsModalService, private dateAdapter: DateAdapter, private activeRouter: ActivatedRoute,
    private _cdr: ChangeDetectorRef) {

    this.dayModifier = ((day: SchedulerViewDay): void => {
      day.cssClass = this.isDateValid(day.date) ? '' : 'cal-disabled';
    }).bind(this);

    this.segmentModifier = ((segment: SchedulerViewHourSegment): void => {
      segment.isDisabled = !this.isDateValid(segment.date);
    }).bind(this);

    this.eventModifier = ((event: CalendarSchedulerEvent): void => {
      event.isDisabled = !this.isDateValid(event.start);
    }).bind(this);

    this.dateOrViewChanged();
  }

  ngOnInit(): void {
    let date = new Date()
    this.maxdate = new Date(`${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear() - 18}`);
    this.activeRouter.params.subscribe(data => {
      if (data) {
        this.doctorId = data.id;
      }
    })
    this.doctorService.getGender().subscribe(gender$ => {
      this.gender = gender$;
    });
    this.getSchedular(this.viewDate);
    // this.getMember_Details();
  }

  /**
   * This method for to get information of unavailable appointments of doctor schedule.
   * To show unavailble text on calander schedule.
   * @param date 
   */
  async getSchedular(date) {
    this.events = []
    let finalDate = new Date().setDate(date.getDate() + 6);
    let obj = {
      fromDate: format(date, 'dd-MM-yyyy'),
      endDate: format(finalDate, 'dd-MM-yyyy'),
      doctorId: this.doctorId
    };
    this.doctorService.bookingScheduler(obj).subscribe(async data => {
      let getdata: any = data;
      this.dayEndHour = getdata.availabilityEndTime;
      this.dayStartHour = getdata.availabilityStartTime;
      await getdata.calenderEvents.forEach(ele => {
        let eventData: CalendarSchedulerEvent = {
          id: ele.id,
          start: startOfMinute(new Date(ele.start)),
          //end: addMinutes(startOfHour(addHours(new Date(1628506217195), 0)), 29),
          end: addMinutes(startOfMinute(new Date(ele.end)), ele.interval),
          title: ele.title,
          content: ele.content,
          color: ele.color,
          actions: this.actions,
          // status: 'ok' as CalendarSchedulerEventStatus,
          isClickable: ele.clickable,
          isDisabled: ele.disabled
        }
        this.events.push(eventData);
      });
      this.refresh.next();
    });
  }

  /**
   * This method to get logged in user info and display on input field
   */
  getMember_Details() {
    this.doctorService.getmemberDetails().subscribe(data => {
      let getmemberDInfo$: any = data
      this.requestForm.get('detailsDto.firstName').patchValue(getmemberDInfo$.firstName);
      this.requestForm.get('detailsDto.lastName').patchValue(getmemberDInfo$.lastName);
      this.requestForm.get('detailsDto.genderId').patchValue(getmemberDInfo$.gender != null ? getmemberDInfo$.gender.genderId : null);
      this.requestForm.get('detailsDto.dob').patchValue(getmemberDInfo$.dob);
      this.requestForm.get('detailsDto.phoneNumber').patchValue(getmemberDInfo$.phoneNumber);
    })
  }

  /**
   * This method to access upload file details and validate file size,supported file extensions
   * and files push into one array variable.
   * @param event This param is for get upload file info.
   */
  fileUpload(event: any) {
    if (event.target.files.length) {
      for (let file in event.target.files) {
        if (!isNaN(Number(file))) {
          let currentFile = event.target.files[file]
          let fileExtension = currentFile.name.substring(currentFile.name.lastIndexOf(".")).toLowerCase();
          let acceptedFilesArray = this.acceptFilesFormat.toLowerCase().split(",");
          if (acceptedFilesArray.indexOf(".") === -1 && acceptedFilesArray.indexOf(fileExtension) === -1) {
            Swal.fire({
              title: `Unsupported File`,
              icon: 'info',
            })
          } else if (currentFile.size > 2097152) {
            Swal.fire({
              title: `Upload file size should not exceed 2MB `,
              icon: 'info',
            })
          } else {
            this.fileName.push(event.target.files[file])
          }
        }
      };
    }

  }

  removeFile(file) {
    let index = this.fileName.indexOf(file);
    if (index > -1) {
      this.fileName.splice(index, 1);
    }
    return this.fileName
  };

  /**
   * This method is to sumbit user infomation select appointment date 
   * and consultation of mode like video,call or email.
   * If req is success,to navigate to confirmation page for booking appointment
   */

  async submitReq_Form() {
    this.requestForm.get('doctorId').patchValue(this.doctorId);
    if (!this.requestForm.valid) {
      this.requestForm.markAllAsTouched();
      this.scroller.scrollToAnchor('formerrors')
      return false;
    } else {
      let date: any = this.requestForm.get('appointmentDate').value;
      if (date) {
        this.requestForm.get('appointmentTime').patchValue(date);
      }
      let reqAppoinment = new FormData();
      for (let file in this.fileName) {
        reqAppoinment.append('files', this.fileName[file]);
      }
      reqAppoinment.append('formData', JSON.stringify(this.requestForm.value));
      this.doctorService.postRequestAppoinment(reqAppoinment).subscribe(data => {
        let getData: any = data
        if (getData.result) {
          this.modalService.hide();
          this.doctorService.setAppointment(getData.bookAppointmentDTO);
          this.events = [];
          this.router.navigate(['/confirm-appointment', getData.bookAppointmentDTO.appointmentId]);
          reqAppoinment.delete('files');
          reqAppoinment.delete('formData');
          this.fileName = []
        }else{
          this.modalService.show(this.modalRef, {
            class: 'mymodal1',
            initialState:{ message:getData.message}
            
          });
        }

      });

    }
  };
  getValues(data: any) {
    if (data.typename) {
      this.typeToWhom = data.typename;
      (data.typename == "MYSELF") ? this.getMember_Details() : this.requestForm.reset({ value: '' });
      this.requestForm.reset({ value: "" });
      this.typeMode = ''
      this.requestForm.get('toWhom').patchValue(data.typename);
    } else if (data.mode) {
      this.typeMode = data.mode;
      this.requestForm.get('modeOfConsultation').patchValue(data.mode);
    }
  }

  openModal(temp) {
    this.modalService.show(temp, {
      class: 'modal-dialog'
    });
  };

  viewDaysOptionChanged(viewDays: number): void {

    this.calendarScheduler.setViewDays(viewDays);
 
  }

  changeDate(date: Date): void {
    this.viewDate = date;
    this.dateOrViewChanged();
  }

  changeView(view: CalendarView): void {
    this.view = view;
    this.dateOrViewChanged();
  }

  dateOrViewChanged(): void {
    if (this.startsWithToday) {
      this.prevBtnDisabled = !this.isDateValid(subPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, this.viewDate, 1));
      this.nextBtnDisabled = !this.isDateValid(addPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, this.viewDate, 1));
    } else {
      this.prevBtnDisabled = !this.isDateValid(endOfPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, subPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, this.viewDate, 1)));
      this.nextBtnDisabled = !this.isDateValid(startOfPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, addPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, this.viewDate, 1)));
    }
    if (this.viewDate < this.minDate) {
      this.changeDate(this.minDate);
    } else if (this.viewDate > this.maxDate) {
      this.changeDate(this.maxDate);
    }
  }

  private isDateValid(date: Date): boolean {
    return /*isToday(date) ||*/ date >= this.minDate && date <= this.maxDate;
  }

  viewDaysChanged(viewDays: number): void {
    this.viewDays = viewDays;
  }

  dayHeaderClicked(day: SchedulerViewDay): void {
    // console.log('dayHeaderClicked Day', day);
  }

  // hourClicked(hour: SchedulerViewHour): void {
  //   console.log('hourClicked Hour', hour);
  // }

  /**
   * This method for to update user selected appointment date to 
   * appointment input field and calendar
   * @param segment This param get user selected date and time
   */
  segmentClicked(action: string, segment: SchedulerViewHourSegment): void {
    this.count++;
    if (this.count == 1) {
      this.requestForm.get('appointmentDate').patchValue(segment.date);
      segment.backgroundColor = '#e8fde7';
      segment.isDisabled = true;
      let eventData: CalendarSchedulerEvent = {
        id: "",
        start: startOfMinute(new Date(segment.date)),
        color: { primary: '#e8fde7', secondary: '#e8fde7' },
        title: " ",
        actions: this.actions,
        isClickable: true,
      }
      this.events.push(eventData);
      this.refresh.next();
      this.modalService.hide();
    }
  }

  eventClicked(action: string, event: CalendarSchedulerEvent): void {
    // console.log('eventClicked Action', action);
    // console.log('eventClicked Event', event);
  }

  eventTimesChanged({ event, newStart, newEnd, type }: SchedulerEventTimesChangedEvent): void {
    const ev: CalendarSchedulerEvent = this.events.find(e => e.id === event.id);
    ev.start = newStart;
    ev.end = newEnd;
    this.refresh.next();
  }




}
